import { notification } from '@iso/components';

export function safe(worker, mensajeError) {
  return function* (...args) {
    try {
      yield* worker(...args);
    } catch (error) {
      console.error(error);
      const msg =
        error?.response?.data?.msg ||
        error?.message ||
        mensajeError ||
        'Error de conexión con el servidor. Inténtalo de nuevo.';
      notification('error', msg);
    }
  };
}
